import { utils } from '@febos-io/common';

export const searchPatientByFilter = (pages, limit, filter, query) => ({
  path: 'v1/tools/search/patients',
  params: {
    pages,
    limit,
    filtros: filter,
    q: query
  }
});

export const searchPatientInCompany = (companyId, pages, limit, query) => ({
  path: `/v1/companies/${companyId}/patients/search`,
  method: utils.METHOD.POST,
  params: {
    pages,
    limit,
  },
  content: query,
  config: {
    alias: 'search.patient'
  }
});

export const getReport = (type, page, format, limit = 1, filter = undefined) => ({
  path: `v1/tools/search/${type}`,
  params: {
    formato: format,
    pagina: page,
    elementosPorPagina: limit,
    filtros: filter
  }
});

export const getIndicator = (type, operation, fields, filter) => ({
  path: `v1/tools/search/${type}/indicator`,
  params: {
    operacion: operation,
    debug: 'si',
    campos: fields,
    filtros: filter
  }
});

export const searchExam = (body, filter: string | undefined = undefined, type = 'dental-exam', alias = '') => ({
  path: `v1/tools/search/${type}`,
  method: utils.METHOD.POST,
  params: {
    filtros: filter
  },
  content: body,
  config: {
    alias
  }
});

export const registreMetric = (body) => ({
  path: `v1/metrics`,
  method: utils.METHOD.POST,
  content: body,
  config: {
    alias: 'registre.metric'
  }
});
